import React, {useEffect, useMemo, useState} from "react";
import {createTheme, ThemeProvider} from "@mui/material/styles";

/**
 * Bridges Tailwind's class-based dark mode to MUI's palette mode.
 * Watches the `dark` class on <html> and provides a MUI theme whose
 * palette.mode matches, so MUI components (Skeleton, CircularProgress,
 * Combobox menus, etc.) render correctly in dark mode.
 */
export default function MuiThemeBridge({children}) {
    const [mode, setMode] = useState(
        () => (typeof document !== "undefined" &&
            document.documentElement.classList.contains("dark")) ? "dark" : "light"
    );

    useEffect(() => {
        const root = document.documentElement;
        const observer = new MutationObserver(() => {
            setMode(root.classList.contains("dark") ? "dark" : "light");
        });
        observer.observe(root, {attributes: true, attributeFilter: ["class"]});
        return () => observer.disconnect();
    }, []);

    const theme = useMemo(
        () => createTheme({
            palette: {
                mode,
                primary: {main: "#db2777"}, // pink-600, matches the brand accent
            },
        }),
        [mode]
    );

    return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
